export default {
  "content": "<path d=\"M1.875 13.125l4.3-4.3a1.875 1.875 0 012.65 0l4.3 4.3m-1.25-1.25l1.174-1.174a1.875 1.875 0 012.652 0l2.424 2.424m-15 3.125h13.75c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H3.125c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25zm8.75-9.375h.006v.006h-.006v-.006zm.313 0a.312.312 0 11-.625 0 .312.312 0 01.624 0z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none"
  }
};